<template>
  <section class="fixes" aria-labelledby="fixes-title">
    <div class="fixes-head">
      <div>
        <p class="fixes-eyebrow">Fix these first</p>
        <h2 id="fixes-title" class="fixes-title">{{ title }}</h2>
      </div>
      <p class="fixes-note">Ranked by weight and how far off each check is</p>
    </div>
    <ol class="fixes-list">
      <li v-for="(fix, index) in fixes" :key="`${fix.category}-${fix.name}`" class="fixes-row">
        <span class="fixes-rank" aria-hidden="true">{{ index + 1 }}</span>
        <div class="fixes-body">
          <p class="fixes-name">
            {{ fix.name }}
            <span class="fixes-category">{{ categoryLabel(fix.category) }}</span>
          </p>
          <div class="fixes-how">
            <strong>How to fix: </strong>
            <div class="fixes-description" v-html="sanitise(fix.description)" />
          </div>
        </div>
        <check-status class="fixes-status" :check="fix" variant="meter" />
      </li>
    </ol>
  </section>
</template>

<script>
import CheckStatus from './CheckStatus.vue'
import sanitiseHtml from '../score/sanitiseHtml'
import { getCategoryLabel } from '../score/report.mjs'

const COUNT_TITLES = ['', 'The fix with the biggest impact', 'Two fixes with the biggest impact', 'Three fixes with the biggest impact', 'Four fixes with the biggest impact', 'Five fixes with the biggest impact']

export default {
  name: 'FixesFirst',
  components: { CheckStatus },
  props: {
    // From rankFixes(): five at most, each with its category.
    fixes: { type: Array, required: true }
  },
  computed: {
    title () {
      return COUNT_TITLES[this.fixes.length]
    }
  },
  methods: {
    categoryLabel: getCategoryLabel,
    sanitise: sanitiseHtml
  }
}
</script>

<style scoped>
.fixes {
  padding: 32px;
  border: 1px solid var(--ex-color-hairline);
  border-radius: var(--ex-radius-panel-large);
  background: var(--ex-color-white);
}

.fixes-head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px 24px;
}

.fixes-eyebrow {
  margin-bottom: 14px;
  font-size: 14px;
  font-weight: 600;
  color: var(--ex-color-blue);
}

.fixes-title {
  font-size: 30px;
  letter-spacing: -0.035em;
  line-height: 1.08;
}

.fixes-note {
  font-size: 13px;
  color: var(--ex-color-neutral-500);
}

.fixes-list {
  margin: 20px 0 0;
  padding: 0;
  list-style: none;
}

.fixes-row {
  display: grid;
  grid-template-columns: 36px 1fr 200px;
  gap: 16px;
  align-items: start;
  padding: 18px 0;
  border-top: 1px solid var(--ex-color-hairline);
}

.fixes-rank {
  font-family: var(--ex-font-heading);
  font-size: 22px;
  font-weight: 600;
  color: var(--ex-color-neutral-300);
}

.fixes-name {
  font-size: 16px;
  font-weight: 600;
}

.fixes-category {
  margin-left: 10px;
  font-size: 13px;
  font-weight: 400;
  color: var(--ex-color-neutral-500);
}

.fixes-how {
  margin-top: 10px;
  padding: 12px 16px;
  border-radius: var(--ex-radius-tile);
  background: var(--ex-color-surface-blue);
  font-size: 14px;
  line-height: 1.55;
}

.fixes-how strong {
  float: left;
  margin-right: 4px;
  font-weight: 600;
}

.fixes-description ::v-deep p {
  margin: 0;
}

.fixes-description ::v-deep p + p {
  margin-top: 8px;
}

.fixes-status {
  justify-self: end;
  margin-top: 4px;
}

@media (max-width: 760px) {
  .fixes {
    padding: 24px 20px;
  }

  .fixes-row {
    grid-template-columns: 28px 1fr;
  }

  .fixes-status {
    grid-column: 2;
    justify-self: start;
  }
}
</style>
